import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {InteractionApiService} from "../../api/interaction-api.service";
import {UserInteractionTypeDto} from "../../types/ds-interaction.types";
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {InteractionStepComponent} from "../interaction-step/interaction-step.component";


@Component({
  selector: 'app-interaction-final',
  templateUrl: './interaction-final.component.html',
  styleUrls:['interaction-final.component.scss']
})
export class InteractionFinalComponent extends InteractionStepComponent implements OnInit {

  @Input() startInteractionType!: UserInteractionTypeDto;




}
